import React, { useEffect, useState } from 'react';
import './ForgeHistory.css';
import { SpinnerDotted } from 'spinners-react';
import config from '../../config'

import closeX from '../../assets/images/nft-icons/close_button.svg';

const baseCID = config.BASE_CID;

// TODO: Create generic api methods;
const apiGet = (url) => {
    return fetch(baseCID + url)
        .then(res => res.json())
        .then(
            (result) => {
                //console.log('result',result);
                return result;
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {

                console.log('***Error:', error);

                return null;
            }
        )
}

const ForgeHistory = ({ tokenId, onClose }) => {

    const [showLoader, setShowLoader] = useState(false);
    const [forgeHistory, setForgeHistory] = useState([]);

    useEffect(() => {
        if (tokenId && tokenId !== '') {
            setShowLoader(true);
            apiGet('/forge/history/' + tokenId).then(res => {
                if (res) {
                    setForgeHistory(res);
                }
                setShowLoader(false);
            })
        }

    }, [tokenId])

    useEffect(() => {
        if (forgeHistory) {
            console.info(forgeHistory)
        }
    }, [forgeHistory])


    const closeClicked = () => {
        if (onClose) {
            setForgeHistory([]);
            onClose();
        }
    }

    return (
        <div className={`forge-history-container ${tokenId && tokenId !== '' ? 'show' : ''}`}>
            <div className="container text-center p-3" style={{ position: 'relative', height: '100%', width: '100%' }}>
                <h4>
                    Forge History
                </h4>
                <div className="forge-list-container">
                    {
                        forgeHistory && forgeHistory.length > 0 && forgeHistory.map((history, index) => {
                            return (
                                <div key={`${history.id}`}>
                                    {
                                        index == 0 ?
                                            <>
                                                <div className="forge-list-row row p-3">
                                                    {index + 1}.
                                                {
                                                        history.action.old.layerName.map((name, index) => {
                                                            return <div key={`${name}.${index}.1`} className="forge-list-item col text-center" style={{ maxWidth: '20%', minWidth: '100px' }}>
                                                                {name}
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                <div className="forge-list-row row p-3">
                                                    {index + 2}.
                                                {
                                                        history.action.new.layerName.map((name, index) => {
                                                            return <div key={`${name}.${index}.2`} className="forge-list-item col text-center" style={{ maxWidth: '20%', minWidth: '100px' }}>
                                                                {name}
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </>
                                            :
                                            <div className="forge-list-row row p-3">
                                                {index + 2}.
                                                {
                                                    history.action.new.layerName.map((name, index) => {
                                                        return <div key={`${name}.${index}.3`} className="forge-list-item col text-center" style={{ maxWidth: '20%', minWidth: '80px' }}>
                                                            {name}
                                                        </div>
                                                    })
                                                }
                                            </div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            {!showLoader && forgeHistory.length == 0 &&
                <div className="text-center" style={{ margin: 'auto' }}>
                    No history..
                </div>
            }
            {
                showLoader &&
                <div className="history-loader">
                    <SpinnerDotted enabled={true} size={35} thickness={160} speed={200} color="#fff" />
                </div>
            }
            <div className='close-btn' onClick={closeClicked}>
                <img src={closeX} />
            </div>
        </div >
    )
}
export default ForgeHistory;